import React, { useState } from "react";
import { useSelector } from "react-redux";
import { CustomTabs } from "../../../Components/CustomTabs";
import { SalesReturnView } from "./SalesReturnView";
import { SaleReturnInventory } from "./SaleReturnInventory";
import { ReworkEntryView } from "../../Invoice/Rework Entry/ReworkEntryView";
export const SalesReturnAllTabView = () => {
  const userData = useSelector((state) => state.auth.profile);

  const isInGroups = (...groups) =>
    groups.some((group) => userData.groups.includes(group));

  const tabs = [
    {
      label: "Sales Return",
      roles: ["Director", "Accounts", "QA"],
      component: <SalesReturnView />,
    },
    {
      label: "Sales Return Inventory",
      roles: ["Director", "Accounts", "Production"],
      component: <SaleReturnInventory />,
    },
    {
      label: "Rework Entry",
      roles: ["Director", "Accounts", "Production"],
      component: <ReworkEntryView />,
    },
  ];

  const visibleTabs = tabs.filter((tab) => isInGroups(...tab.roles));

  // Simplified active tab state to always start with the first item of visibleTabs if available
  const [activeTab, setActiveTab] = useState(0);

  const onTabChange = (newIndex) => {
    setActiveTab(newIndex);
  };

  return (
    <>
      <CustomTabs
        tabs={visibleTabs.map((tab) => ({
          label: tab.label,
          index: tab.index,
        }))}
        activeTab={activeTab}
        onTabChange={onTabChange}
      />
      {visibleTabs.length > 0 && visibleTabs[activeTab] ? (
        <div>{visibleTabs[activeTab].component}</div>
      ) : null}
    </>
  );
};
